module.exports = __webpack_public_path__ + "img/dndfszd.2cc4ca99.png";